module.exports = __webpack_public_path__ + "img/kgd_logo.39285a7e.png";